import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-393">
      <div className="max-w-5xl mx-auto" data-id="element-394">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-395">
          Lo que <span className="text-[#00E676]" data-id="element-396">recibís</span>
        </h2>

        <div className="max-w-2xl mx-auto mb-12" data-id="element-397">
          <div className="bg-black border border-[#00E676]/30 rounded-2xl p-6" data-id="element-398">
            <h3 className="text-[#00E676] text-xl font-black mb-2" data-id="element-399">
              🧬 SECUNDARIA — 6 Tomos
            </h3>
            <p className="text-gray-400 text-sm mb-5" data-id="element-400">
              Para docentes de Biología de 1º a 6º año
            </p>
            <div className="space-y-4" data-id="element-401">
              <div className="flex items-center gap-3 text-white" data-id="element-402">
                <span className="text-xl" data-id="element-403">📘</span>
                <div className="flex-1" data-id="element-404">
                  <span className="font-bold" data-id="element-405">Tomo 1 — 1º Año:</span>
                  <span className="text-gray-300" data-id="element-406">
                    {' '}
                    La Vida, la Célula y el Ambiente
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-407">
                <span className="text-xl" data-id="element-408">📗</span>
                <div className="flex-1" data-id="element-409">
                  <span className="font-bold" data-id="element-410">Tomo 2 — 2º Año:</span>
                  <span className="text-gray-300" data-id="element-411">
                    {' '}
                    Evolución, ADN y Reproducción
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-412">
                <span className="text-xl" data-id="element-413">📙</span>
                <div className="flex-1" data-id="element-414">
                  <span className="font-bold" data-id="element-415">Tomo 3 — 3º Año:</span>
                  <span className="text-gray-300" data-id="element-416">
                    {' '}
                    Sistema Nervioso, Endocrino y Homeostasis
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-417">
                <span className="text-xl" data-id="element-418">📕</span>
                <div className="flex-1" data-id="element-419">
                  <span className="font-bold" data-id="element-420">Tomo 4 — 4º Año:</span>
                  <span className="text-gray-300" data-id="element-421">
                    {' '}
                    Genética, Herencia y Biotecnología
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-422">
                <span className="text-xl" data-id="element-423">📓</span>
                <div className="flex-1" data-id="element-424">
                  <span className="font-bold" data-id="element-425">Tomo 5 — 5º Año:</span>
                  <span className="text-gray-300" data-id="element-426">
                    {' '}
                    Fisiología Humana Integrada
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-427">
                <span className="text-xl" data-id="element-428">📔</span>
                <div className="flex-1" data-id="element-429">
                  <span className="font-bold" data-id="element-430">Tomo 6 — 6º Año:</span>
                  <span className="text-gray-300" data-id="element-431">
                    {' '}
                    Ambiente, Sociedad y Desarrollo Sustentable
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* What each tome includes */}
        <div className="bg-[#00E676]/5 border border-[#00E676]/30 rounded-2xl p-8 text-center" data-id="element-432">
          <h3 className="text-[#00E676] text-xl font-black mb-6" data-id="element-433">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-434">
            <div className="flex items-start gap-2 text-left" data-id="element-435">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-436">✅</span>
              <span className="text-white text-sm" data-id="element-437">
                Planificación anual completa lista para entregar a jefatura o
                inspección
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-438">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-439">✅</span>
              <span className="text-white text-sm" data-id="element-440">
                5 Unidades Didácticas con desarrollo teórico completo y ejemplos
                argentinos
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-441">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-442">✅</span>
              <span className="text-white text-sm" data-id="element-443">
                Secuencias didácticas con estructura inicio–desarrollo–cierre
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-444">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-445">✅</span>
              <span className="text-white text-sm" data-id="element-446">
                Actividades fotocopiables listas para imprimir o compartir por
                WhatsApp
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-447">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-448">✅</span>
              <span className="text-white text-sm" data-id="element-449">
                Evaluación diagnóstica + 3 evaluaciones trimestrales con
                criterios de corrección
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-450">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-451">✅</span>
              <span className="text-white text-sm font-bold" data-id="element-452">
                SOLUCIONARIO COMPLETO con todas las respuestas y justificaciones
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-453">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-454">✅</span>
              <span className="text-white text-sm" data-id="element-455">
                Glosario biológico con los términos clave de cada año
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-456">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-457">✅</span>
              <span className="text-white text-sm" data-id="element-458">
                Bibliografía curricular certificada — DCP Nacional + provincias
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-459">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-460">✅</span>
              <span className="text-white text-sm" data-id="element-461">
                100% alineado a Diseños Curriculares argentinos
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-462">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-463">✅</span>
              <span className="text-white text-sm" data-id="element-464">
                Contenidos de ESI integrados (Ley 26.150)
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-465">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-466">✅</span>
              <span className="text-white text-sm" data-id="element-467">
                Datos epidemiológicos argentinos actualizados
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}